export default "__VITE_ASSET__DAVJaSli__"